module.exports = __webpack_public_path__ + "static/media/contact-cloud-logo.0d9b6060.png";